module.exports = __webpack_public_path__ + "static/media/special.fbcb9132.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special.png
// module id = 765
// module chunks = 0 1